import { HttpStatusCode } from 'axios';

import { ApiError } from 'types/api/ApiError';

/**
 * Maps an axios-shaped error's response body into {@link ApiError}.
 * For 5xx responses, keeps the fallback message (avoids surfacing raw server text).
 */
export function toApiError(
  error: any,
  fallbackMessage: string,
  status?: number
): ApiError {
  const responseData = error?.response?.data;
  let message = fallbackMessage;

  if (status == null || status < HttpStatusCode.InternalServerError) {
    if (typeof responseData === 'string') {
      message = responseData;
    } else if (
      typeof responseData?.message === 'string' &&
      responseData.message.length > 0
    ) {
      message = responseData.message;
    } else if (
      typeof responseData?.error === 'string' &&
      responseData.error.length > 0
    ) {
      message = responseData.error;
    }
  }

  return {
    message,
    status,
    level: responseData?.level || responseData?.errorLevel,
  };
}
